import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'nirby-directorys',
    templateUrl: './directorys.component.html',
    styleUrls: ['./directorys.component.scss'],
})
export class DirectorysComponent {
}
